import React, { Component } from 'react'
import { connect } from 'react-redux'

import Divider from 'material-ui/Divider'

import Events from './events'
//import Communication from 'components/Communication'


export default class RightSide extends Component{
	render(){
		let { props } = this
		let oneColumn = this.props.colspan == 1
		return(
			<div className="rightSide"
				style={{
					width: (this.props.colspan>1)?"50%":"100%"
				  , clear:"both"
				  , position: "relative"
				  , display: "block"
				  , overflowY: "auto"
				  , marginTop: "2px"
				  , padding: "8px"
				}}
			>
				<div className="wrapper"
					style={{
						paddingBottom: "10px"
					  , overflow:"hidden"
					}}
				>
					<Events propertyID={this.props.propertyID} top={true} />
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/propertyForm/RightSide.js